export default __webpack_public_path__ + "static/media/img-39-alwin.8b65c1bc.jpg";